import { render, staticRenderFns } from "./RiskIndicatorChips.html?vue&type=template&id=63779748&external"
import script from "./RiskIndicatorChips.vue?vue&type=script&lang=js"
export * from "./RiskIndicatorChips.vue?vue&type=script&lang=js"
import style0 from "./RiskIndicatorChips.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports